import React from 'react';
import { Grid, Typography, Card, CardHeader, CardContent } from '@mui/material';
import { useApiGet } from '../../utils/httpClient';
import { getUserProjects } from '../../endpoints/users';

export default function UserProjects({ id }) {
  const { data: userProjects, isLoading } = useApiGet(
    ['userProjects', id],
    getUserProjects,
    {
      enabled: !!id,
    },
    { id }
  );
  if (isLoading) {
    return (
      <Grid container>
        <Grid item xs={12} padding>
          <Typography variant="h6">Loading...</Typography>
        </Grid>
      </Grid>
    );
  }
  if (!userProjects) {
    return (
      <Grid container>
        <Grid item xs={12} padding>
          <Typography variant="h6">Projects not found</Typography>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container>
      {userProjects.map((project) => (
        <Grid item xs={12} md={6} padding key={project.id}>
          <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
            <CardHeader title={project.college} sx={{ p: 1 }} />
            <CardContent sx={{ p: 1 }}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="body1" component={'span'}>
                    <strong>Project Name:</strong> {project.project_name}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" component={'span'}>
                    <strong>Status:</strong>{' '}
                    {project.status ? project.status : 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" component={'span'}>
                    <strong>Award Year:</strong>{' '}
                    {project.award_year ? project.award_year : 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
      {userProjects.length === 0 && (
        <Grid item xs={12} padding textAlign="center">
          <Typography variant="body1">No projects available</Typography>
        </Grid>
      )}
    </Grid>
  );
}
